import type { SimilarJobOffers } from '~/business/JobOffer/getSimilarJobOffers';
import { Head, NOINDEX_FOLLOW } from '~/components/Head';
import { LatestJobOffersCard } from '~/components/LatestJobOffersCard/LatestJobOffersCard';
import { SEOHeader } from '~/components/SEOHeader';
import { SEOContainer, SEOText } from '~/components/SEOText';
import { useTranslation } from '~/hooks';

import { getSimilarOffersTitle } from './similarOffersTitle';

export type MissionExpiredProps = {
  title: string;
  // an external offer may come without an address
  city: string | null;
  searchUrl: string;
  similarJobOffers: SimilarJobOffers;
};

export const MissionExpired = ({ title, city, searchUrl, similarJobOffers }: MissionExpiredProps) => {
  const t = useTranslation();
  const suffix = city ? '' : '_without_city';

  return (
    <>
      <Head title={t(`expired_job_offer.meta_title${suffix}`, { title, city })} robots={NOINDEX_FOLLOW} />
      <SEOHeader title={t('expired_job_offer.title')} />
      <SEOContainer>
        <SEOText content={t(`expired_job_offer.subtitle${suffix}`, { title, city })} />
      </SEOContainer>
      <LatestJobOffersCard
        latestJobOffers={similarJobOffers.jobOffers}
        seeAllOffersPath={searchUrl}
        title={getSimilarOffersTitle(t, similarJobOffers, { title, city })}
      />
    </>
  );
};
